import { Box, Skeleton, Stack } from '@mui/material';

export default function WebhookFormSkeleton() {
  return (
    <Box display='flex' flexDirection='column' flex={1} minHeight={0} mt={2}>
      <Box flex={1} overflow='auto' px={3} pt={1.5} pb={2}>
        <Stack gap={2.5}>
          {Array.from({ length: 3 }, (_, index) => (
            <Box key={`field-${index}`}>
              <Skeleton variant='text' width={120} height={18} sx={{ mb: 1 }} />
              <Skeleton variant='rounded' height={index === 1 ? 72 : 56} />
            </Box>
          ))}

          <Box display='flex' alignItems='center' justifyContent='space-between'>
            <Skeleton variant='text' width={60} height={20} />
            <Skeleton variant='rounded' width={44} height={24} />
          </Box>

          <Box>
            <Skeleton variant='text' width={70} height={18} sx={{ mb: 1 }} />
            <Skeleton variant='rounded' height={56} />
          </Box>
        </Stack>
      </Box>

      <Box
        display='flex'
        gap={1.5}
        justifyContent='flex-end'
        px={3}
        py={2}
        sx={{
          borderTop: '1px solid #EAEAEA',
          backgroundColor: 'background.paper',
          flexShrink: 0
        }}
      >
        <Skeleton variant='rounded' width={88} height={40} sx={{ borderRadius: 24 }} />
        <Skeleton variant='rounded' width={140} height={40} sx={{ borderRadius: 24 }} />
      </Box>
    </Box>
  );
}
